const deleteAddDocumentServices = {
  toastr: 'Deleted document',
  toastr1: 'The document was successfully deleted.'
};

export default deleteAddDocumentServices;
